import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";
import { humanReadableNumber } from "common/utility";

const RadialChart = ({ dataColors, supply }) => {
  const radialChartColors = getChartColorsArray(dataColors);
  console.log(supply, "supply");
  const series = [supply];
  const options = {
    plotOptions: {
      radialBar: {
        dataLabels: {
          name: {
            fontSize: "22px",
          },
          value: {
            fontSize: "16px",
          },
          total: {
            show: true,
            label: "Total Supply",
            formatter: function (data) {
              return humanReadableNumber(data?.config?.series[0]);
            },
          },
        },
      },
    },

    labels: ["Total Supply", "The Little Things", "Blu Kiosk", "MUMUSO"],
    colors: radialChartColors,
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height="280"
      className="apex-charts"
    />
  );
};

export default RadialChart;
